import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { ViewComponent } from './view/view.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { HomeComponent } from './home/home.component';
import { ArchitectureComponent } from './architecture/architecture.component';
import { AdminComponent } from './admin/admin.component';
import { PowerbiComponent } from './powerbi/powerbi.component';
import { ArchitecturePrintComponent } from './architecture/architecture-print/architecture-print.component';
import { ChangelogComponent } from './changelog/changelog.component';
import { FAQComponent } from './faq/faq.component';
import { AuthGuardService } from './services/auth-guard.service';
import { GetPowerBIComponent } from './get-power-bi/get-power-bi.component';
import { IframeComponent } from './iframe/iframe.component';
import { LoginRedirectComponent } from './login-redirect/login-redirect.component';
import { isDevEnv } from './services/util.service';

const routes: Routes = [

  { path: 'login', component: LoginComponent }, // not implemented
  { path: 'loginRedirect', component: LoginRedirectComponent },
  {

    path: '', component: ViewComponent,
    children: [
      {
        path: '',
        // redirectTo: skip() ? '/landscape' : '/home',
        redirectTo: '/landscape',
        pathMatch: 'full'
      },
      {
        path: 'home',
        component: HomeComponent,
        pathMatch: 'prefix',
        canActivate: [AuthGuardService]
      },
      {
        path: 'landscape',
        component: ArchitectureComponent,
        pathMatch: 'prefix',
        canActivate: [AuthGuardService]
      },
      {
        path: 'admin',
        component: AdminComponent,
        pathMatch: 'prefix',
        canActivate: [AuthGuardService]
      },
      {
        path: 'changelog',
        component: ChangelogComponent,
        pathMatch: 'prefix'
      },
      {
        path: 'powerbi',
        component: PowerbiComponent,
        pathMatch: 'prefix'
      },
      {
        path: 'faq',
        component: FAQComponent,
        pathMatch: 'prefix',
        canActivate: [AuthGuardService]
      },
      {
        path: 'getpowerbi',
        component: GetPowerBIComponent,
        pathMatch: 'prefix'
      }
    ]
  },

  { path : 'print' , component: ArchitecturePrintComponent},

];

const devRoutes: Routes = [
  { path : 'iframe' , component: IframeComponent},
];

const noMatchRoutes: Routes = [
  { path: '**', component: PageNotFoundComponent },
];

let allRoutes: Routes = [];
if (isDevEnv()) {
  allRoutes = routes.concat(devRoutes).concat(noMatchRoutes);
} else {
  allRoutes = routes.concat(noMatchRoutes);
}

@NgModule({
  imports: [RouterModule.forRoot(allRoutes,
    {
      // Martin has updated the Apache so we don't have to use the #
      // useHash: true
    })],
  exports: [RouterModule]
})
export class AppRoutingModule { }

function skip() {
  let name = "lndscp-close-splash"
  let ca: Array<string> = document.cookie.split(';');
  let caLen: number = ca.length;
  let cookieName = `${name}=`;
  let c: string;

  for (let i: number = 0; i < caLen; i += 1) {
    c = ca[i].replace(/^\s+/g, '');
    if (c.indexOf(cookieName) == 0) {
      return c.substring(cookieName.length, c.length) == "true";
    }
  }
  return false;

}
